// Importing necessary libraries and components
import {getCurrentUser } from '@aws-amplify/auth';
import React, { useState, useRef, useEffect } from 'react'
import {Background} from '../components/background.js'
import './App.css'
import  ForecastPage  from './forecastPage.js';
import GraphSelectorPage from './GraphSelectorPage.js';
import MasterPage from './MasterPage.js';
import getTheme from "../components/color-pallete";
import { ThemeProvider } from "@emotion/react";
import LoadingAnimation from './LoadingAnimation.js';
import { useUserPowerplants } from '../api/GetData.js';
// Main App component

function App ({SignOut}) {
  // State variables
  const {data: allowedPlants} = useUserPowerplants()
  const [Showpage, SetGraphPage] = useState("CustomerPersona");
  const [ActivePage, SetActivePage] = useState("CustomerPersona");
  const [ActivePage2, SetActiveShowPage] = useState("CustomerPersona");
  const [LastPage, SetLastPage] = useState("CustomerPersona");
  const [activePlant, setActivePlant] = useState(null);
  const signedInRef = useRef(false)

  useEffect(() => {
  const handleUnload = () => {
    // Can't call async code here
    sessionStorage.setItem('forceLogout', 'true');
  };

  window.addEventListener('beforeunload', handleUnload);
  return () => window.removeEventListener('beforeunload', handleUnload);
}, []);
  // Function to handle sign out
  const handleSignOut = async () => {
    signedInRef.current = false
    SignOut()

  }
  useEffect(() => {
    checkUserSignedIn() 
  }, []);
  

  const checkUserSignedIn = async () =>{
    try {
      await getCurrentUser();
      signedInRef.current = true
      console.log("user signed in")
    } catch (error) {
      console.log('user not signed in')
      signedInRef.current = false
    }
  }

  


const getPlantFromPage = (page) => {
  if (typeof page !== "string") return null;
  if (!page.startsWith("CustomerPersona")) return null;
  return page.includes(":") ? page.slice("CustomerPersona:".length) : null;
};

const changePage = (page) => {
  const nextPlant = getPlantFromPage(page);
  if (nextPlant) {
    setActivePlant(nextPlant);
  }
  if (page === "GraphSelectorPage" && ActivePage === "GraphSelectorPage") {
    // If already on GraphSelectorPage, go back to last page
    SetActivePage(LastPage);
    SetGraphPage(LastPage);
  } else {
    // Normal page change
    SetLastPage(ActivePage);
    SetActivePage(page);
    SetGraphPage(page);
    SetActiveShowPage(Showpage);
  }
  };
const [sidebarSections, setSidebarSections] = useState(() => {
    const saved = localStorage.getItem("sidebarSections");
    return saved
      ? JSON.parse(saved)
      : {
          actualPrice: true,
          forecastPrice: true,
          ailDemand: true,
          renewablesBox: true,
          wisdmStatus: true,
          wilsonCreek: true,
          summary: true,
        };
  });

  useEffect(() => {
    const plantList = Array.isArray(allowedPlants)
      ? allowedPlants
      : (allowedPlants ? [allowedPlants] : []);
    if (plantList.length === 0) {
      return;
    }
    const firstPersona = `CustomerPersona:${plantList[0]}`;
    setActivePlant((prev) => prev || plantList[0]);
    SetGraphPage((prev) => (prev === "CustomerPersona" ? firstPersona : prev));
    SetActivePage((prev) => (prev === "CustomerPersona" ? firstPersona : prev));
    SetActiveShowPage((prev) => (prev === "CustomerPersona" ? firstPersona : prev));
    SetLastPage((prev) => (prev === "CustomerPersona" ? firstPersona : prev));
  }, [allowedPlants]);

  useEffect(() => {
    const pagePlant = getPlantFromPage(Showpage);
    if (pagePlant) {
      setActivePlant(pagePlant);
    }
  }, [Showpage]);
 
  function renderSwitch(param){
    const isPersona = typeof param === "string" && param.startsWith("CustomerPersona");
    const plantName = isPersona && param.includes(":")
      ? param.slice("CustomerPersona:".length)
      : null;
    if (param === "GraphSelectorPage") {
      return <GraphSelectorPage pageKey={ActivePage2} />;
    }
    if (param === "MasterPage") {
      return <MasterPage allowedPlants={allowedPlants} />;
    }
    if (isPersona) {
      return <ForecastPage visibleSections={sidebarSections} pageKey={param} plantName={plantName} />;
    }
    return <ForecastPage visibleSections={sidebarSections} pageKey="CustomerPersona" />;
  }
  return (
    <ThemeProvider theme={getTheme("LionstoothEnergy")}>
    <div>
      {signedInRef
        ? (
        <div>
         <div className="background">
            <Background
              hSignOut={handleSignOut}
              changePage={changePage}
              setSidebarSections={setSidebarSections}
              activePlant={activePlant}
            />
          </div >
            <div className='element'>
              {/* Check which set of graphs to show */}
             {renderSwitch(Showpage)}
          </div>
        </div>
          ) 
        : (
          <div>
            <LoadingAnimation/>
          </div>
          )}
    </div>
    </ThemeProvider>
  )

  // Function to run API calls
  
}

export default App

// Function to get a date string in the format "YYYY-MM-DD" for a date that is "Days" days from the current date

